import { FC } from 'react'
import {
  StyleCardHeader,
  StyleWrapper,
  StyleTag,
  StyleCardFooter,
  StyleLastMeetingWrapper,
} from './style'
import Image from '@components/image'
import Typography from '@components/typography'
import Column from '@components/column'
import Row from '@components/row'
import Button from '@components/button'
import Svg from '@components/svg'
import { format } from 'date-fns'
interface PatientCardProps {
  patient: any
}
const PatientCard: FC<PatientCardProps> = ({ patient }) => {
  return (
    <StyleWrapper>
      <StyleCardHeader>
        <Image
          src={`${process.env.BUCKET_URL}/${patient?.avatar}`}
          styleImage="border-radius:50%;"
          width={50}
          height={50}
          fallbackType="user"
        />
        <Column rowGap={10}>
          <Typography content={patient?.name} size={14} tc="text" />
          <Row colGap={10}>
            <StyleTag>{patient?.infos?.gender}</StyleTag>
            <StyleTag>{patient?.infos?.age}</StyleTag>
            <StyleTag>{patient?.infos?.bloodGroup}</StyleTag>
          </Row>
        </Column>
      </StyleCardHeader>
      <StyleCardFooter>
        <StyleLastMeetingWrapper>
          <Svg svg="calendar" color={'primary'} />
          <Typography
            content={`Last Meeting: ${format(patient?.appointments[0]?.date, 'dd MMM, yyyy HH:mm aa')}`}
            size={12}
            tc="primary"
          />
        </StyleLastMeetingWrapper>
        <Button
          title="View Details"
          height={40}
          styleButton="width:100%;"
          styleButtonWrapper="width:39%;"
          data-cross-id={patient?.id}
        />
      </StyleCardFooter>
    </StyleWrapper>
  )
}

export default PatientCard
